import { useState, useRef, useCallback } from 'react';
import { createPortal } from 'react-dom';
import { Info } from 'lucide-react';

export default function FieldTooltip({ tip, size = 12 }) {
  const [pos, setPos] = useState(null); // { top, left, placement }
  const anchorRef = useRef(null);
  const POPUP_W = 240;

  const show = useCallback(() => {
    if (!anchorRef.current || !tip) return;
    const r = anchorRef.current.getBoundingClientRect();
    const spaceAbove = r.top;
    const spaceRight = window.innerWidth - r.right;

    if (spaceAbove < 90 && spaceRight > POPUP_W + 12) {
      // Abrir a la derecha
      setPos({
        top: r.top + r.height / 2,
        left: r.right + 8,
        placement: 'right',
      });
    } else {
      // Abrir arriba
      setPos({
        top: r.top - 8,        // 8px de gap; el CSS usa translateY(-100%)
        left: r.left + r.width / 2,
        placement: 'top',
      });
    }
  }, [tip]);

  const hide = useCallback(() => setPos(null), []);

  const popoverStyle =
    pos?.placement === 'right'
      ? {
          position: 'fixed',
          top: pos.top,
          left: pos.left,
          transform: 'translateY(-50%)',
          width: POPUP_W,
          zIndex: 99999,
        }
      : {
          position: 'fixed',
          top: pos?.top,
          left: pos?.left,
          transform: 'translate(-50%, -100%)',
          width: POPUP_W,
          zIndex: 99999,
        };

  return (
    <span
      ref={anchorRef}
      className="relative inline-flex items-center align-middle"
      onMouseEnter={show}
      onMouseLeave={hide}
      onFocus={show}
      onBlur={hide}
      tabIndex={0}
      data-testid="field-tooltip"
    >
      <Info
        className="text-white/35 hover:text-white/70 transition-colors cursor-help"
        style={{ width: size, height: size }}
      />
      {pos && tip &&
        createPortal(
          <span
            role="tooltip"
            className="px-3 py-2 rounded-md text-[10px] leading-snug text-white/90 bg-[#1e1e2e] border border-white/10 shadow-lg pointer-events-none"
            style={popoverStyle}
          >
            {tip}
          </span>,
          document.body
        )
      }
    </span>
  );
}
